module.exports = __webpack_public_path__ + "img/ro.edc6ec3b.svg";